import { Facet } from 'engine/facets/Facet';

interface LaserableProps {
  didSucceed: () => boolean,
}

export class Laserable extends Facet<LaserableProps> {
}
